import React, { useEffect, useState } from "react";
import axios from "axios";

const ContactAdmin = () => {
  const [contacts, setContacts] = useState([]);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" });

  // Fetch all contacts
  const fetchContacts = async () => {
    try {
      const res = await axios.get("/api/contacts");
      setContacts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  // Delete contact
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this contact?")) return;
    try {
      await axios.delete(`/api/contacts/${id}`);
      fetchContacts();
    } catch (err) {
      console.error(err);
    }
  };

  // Edit contact
  const handleEdit = (contact) => {
    setEditId(contact._id);
    setFormData({
      name: contact.name,
      email: contact.email,
      phone: contact.phone,
      message: contact.message,
    });
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`/api/contacts/${editId}`, formData);
      setEditId(null);
      setFormData({ name: "", email: "", phone: "", message: "" });
      fetchContacts();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container p-4">
      <h2>Contact Admin Panel</h2>

      {/* Edit Form */}
      {editId && (
        <div className="card mb-3 p-3">
          <h4>Edit Contact</h4>
          <input
            type="text"
            placeholder="Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <input
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          <input
            type="text"
            placeholder="Phone"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
          <textarea
            placeholder="Message"
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          />
          <button className="btn btn-success mt-2" onClick={handleUpdate}>Update</button>
          <button className="btn btn-secondary mt-2 ml-2" onClick={() => setEditId(null)}>Cancel</button>
        </div>
      )}

      {/* Contact Table */}
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Message</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((c) => (
            <tr key={c._id}>
              <td>{c.name}</td>
              <td>{c.email}</td>
              <td>{c.phone}</td>
              <td>{c.message}</td>
              <td>
                <button className="btn btn-primary btn-sm mr-2" onClick={() => handleEdit(c)}>Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(c._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContactAdmin;
